<!--  -->
<template>
  <div class="feeeback">
    <div>
      <h1>Feedback</h1>
      <ul class="feeeback-con">
        <li>
          <p>To recap some of the highlights from today's meeting</p>
          <div v-html="feedbackDetail.highlights">
            {{feedbackDetail.highlights}}
          </div>
        </li>
        <li>
          <p>Example for industry program

            --Leadership and extracurricular experience - you've shown great dedication and breadth --Quality of your internships: fanatatics, the brand names- Mckinse, Bain - are very marketable --Your overall balance between academic achievement and extracurriculars is great- you are very well-rounded and this is something that should be emphasized. As discussed, highlight that trend of increasing GPA year over year, and that it's been a learning process where you've quickly improved.<br /><br />
            Example for industry program<br /><br />
            --Leadership and extracurricular experience - you've shown great dedication and breadth --Quality of your internships: fanatatics, the brand names- Mckinse, Bain - are very marketable --Your overall balance between academic achievement and extracurriculars is great- you are very well-rounded and this is something that should be emphasized. As discussed, highlight that trend of increasing GPA year over year, and that it's been a learning process where you've quickly improved.</p>
          <div v-html="feedbackDetail.bestQualities">
            {{feedbackDetail.bestQualities}}
          </div>
        </li>
        <li>
          <p>Homework</p>
          <div v-html="feedbackDetail.homework">
            {{feedbackDetail.homework}}
          </div>
        </li>
        <li>
          <p>Suggested time for the next meeting</p>
          <div v-html="feedbackDetail.nextMeetingSuggested">
            {{feedbackDetail.nextMeetingSuggested}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-project-feedback1',
  props: ['feedbackDetail'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
